module.exports = __webpack_public_path__ + "static/goerges-profile-9342654b394e1d6ddccf0aab86ad183c.jpg";